<template>
  <app-layout>
    <!-- TODO: remove false when the indicators are fixed -->
    <dashboard-layout v-if="configReady">
      <template v-if="maintenance" slot="header">
        <v-layout>
          <v-flex class="title">
            <v-alert class="ma-5 pa-5" :value="true" color="info" icon="priority_high" outline>
              <p>
                La sección de indicadores está en mantenimiento. Estamos trabajando para que
                funcione lo antes posible.
              </p>
              <p>Disculpen las molestias.</p>
            </v-alert>
          </v-flex>
        </v-layout>
      </template>
      <template v-if="!maintenance" slot="header">
        <v-layout align-center wrap row justify-center>
          <v-flex xs12 sm2 xl1 class="title">
            <h3 class="pa-2">
              {{ $t('Periodo: ') }}
            </h3>
          </v-flex>
          <v-flex xs12 sm10 xl11>
            <aru-period-picker v-model="period"></aru-period-picker>
          </v-flex>
        </v-layout>
      </template>
      <template v-if="!maintenance" slot="first-col">
        <template v-for="(widget, w) in getRegionWidgets('first-col')">
          <v-flex :key="w" v-bind="widget['containerAttrs']">
            <generic-widget
              :widget="widget"
              :numeric-data="numericData"
              :year="year"
              :period="period"
              :userid="clavedat"
            ></generic-widget>
          </v-flex>
        </template>
      </template>
      <template v-if="!maintenance" slot="second-col">
        <template v-for="(widget, w) in getRegionWidgets('second-col')">
          <v-flex :key="w" v-bind="widget['containerAttrs']">
            <generic-widget
              :widget="widget"
              :numeric-data="numericData"
              :year="year"
              :period="period"
              :userid="clavedat"
            ></generic-widget>
          </v-flex>
        </template>
      </template>
      <template v-if="!maintenance" slot="footer-row">
        <template v-for="(widget, w) in getRegionWidgets('footer-row')">
          <v-flex :key="w" v-bind="widget['containerAttrs']">
            <generic-widget
              :widget="widget"
              :numeric-data="numericData"
              :year="year"
              :period="period"
              :userid="clavedat"
            ></generic-widget>
          </v-flex>
        </template>
      </template>
      <template slot="sidebar">
        <v-flex md12>
          <my-consultant-conversation></my-consultant-conversation>
        </v-flex>
        <v-flex md12 pt-3>
          <calendar-events></calendar-events>
        </v-flex>
      </template>
    </dashboard-layout>
  </app-layout>
</template>

<script>
import AppLayout from '@/views/layouts/AppLayout.vue';
import DashboardLayout from '@/views/layouts/DashboardLayout.vue';
import GenericWidget from '../components/widgets/GenericWidget.vue';

import MyConsultantConversation from '@/modules/myconsultant/components/threads/MyConsultantConversation.vue';
import CalendarEvents from '@/modules/calendar/components/CalendarEvents.vue';
import apiCtrl from '@/services/api/abstract/abstract-api.js';
import AruPeriodPicker from '@/components/commons/form/inputs/AruPeriodPicker.vue';
import IndicatorApi from '../services/indicator.js';

export default {
  components: {
    DashboardLayout,
    MyConsultantConversation,
    CalendarEvents,
    AppLayout,
    GenericWidget,
    AruPeriodPicker,
  },
  data() {
    return {
      maintenance: false,
      year: 2022,
      config: {},
      configReady: false,
      period: {
        year: 2022,
        trimester: null,
        startMonth: null,
        endMonth: null,
      },
      numericData: {},
      fab: false,
    };
  },
  mounted() {
    this.setInitialYear();
    this.getDashboardConfig();
    this.getNumericData();
  },
  computed: {
    periodYear() {
      return this.period.year;
    },
    startMonth() {
      return this.period.startMonth;
    },
    endMonth() {
      return this.period.endMonth;
    },

    clavedat() {
      return this.$store.state.clavedat;
    },
  },
  methods: {
    setInitialYear() {
      const date = new Date();
      date.setMonth(date.getMonth() - 1);
      const year = date.getFullYear();
      this.year = year;
      this.period.year = year;
    },

    getNumericData() {
      if (this.clavedat && this.period.year) {
        IndicatorApi.getIGBT(
          this.clavedat,
          this.period.year,
          this.period.startMonth,
          this.period.endMonth,
        ).then(res => {
          console.log({ NUMERICINDICATOR: res.data });
          this.numericData = res.data.data;
          console.log({ NUM: this.numericData });
        });
      }
    },
    getDashboardConfig() {
      this.configReady = false;
      apiCtrl.get('/config/dashboard').then(res => {
        this.config = res.data.data;
        console.log({
          'this.config': this.config,
        });
        this.configReady = true;
      });
    },
    getRegionWidgets(region) {
      let res = [];

      this.config.widgets.forEach(widget => {
        if (widget.hasOwnProperty('region') && widget.region === region) {
          res.push(widget);
        }
      });

      return res;
    },
  },

  watch: {
    periodYear: function() {
      console.log('YEAR CHANGE');
      if (
        this.period.year &&
        ((this.period.startMonth && this.period.endMonth) ||
          (!this.period.startMonth && !this.period.endMonth))
      ) {
        this.getNumericData();
      }
    },
    startMonth: function() {
      console.log('start month CHANGE');

      if (
        this.period.year &&
        ((this.period.startMonth && this.period.endMonth) ||
          (!this.period.startMonth && !this.period.endMonth))
      ) {
        this.getNumericData();
      }
    },
    endMonth: function() {
      console.log('end month CHANGE');

      if (
        this.period.year &&
        ((this.period.startMonth && this.period.endMonth) ||
          (!this.period.startMonth && !this.endMonth))
      ) {
        this.getNumericData();
      }
    },
  },
};
</script>
